export const USControllerCode = "us_ph";
export const ChinaUrlCode = "cn";
export const USUrlCode = "us";
